import { gql } from '@apollo/client';

export const GET_SELECTED_VIEW = gql`
  query GetSelectedView {
    selectedView @client
  }
`;
